import { APIConfig, BaseAPIConfig, buildConfig, ConfigEnvironment, ConfigMap } from "@eres/api";

export interface IPSConfig extends APIConfig {
	maxPropertyImages(): number;

	maxPagesPerDoc(): number;

	maxDocSize(): number;

	psTCUrl(): string;

	setOTP(): boolean;
}

class PSConfig extends BaseAPIConfig implements IPSConfig {
	private _maxPages;
	private _maxPropImage;
	private _tcUrl;
	private _maxDocSize;
	private _setOTP;

	constructor( protocol: string, server: string, app: string, api?: string, maxPages?: number, maxPropImages?: number, maxDocSize?: number, tcUrl?: string, setOTP?: boolean ) {
		super( protocol, server, app, api );
		this._maxPages = maxPages;
		this._maxPropImage = maxPropImages;
		this._maxDocSize = maxDocSize;
		this._tcUrl = tcUrl;
		this._setOTP = setOTP;
	}

	updateFromData( data: any ): boolean {
		const r = super.updateFromData( data );
		if ( data && typeof data === "object" ) {
			if ( data.maxPages ) this._maxPages = data.maxPages;
			if ( data.maxPropImage ) this._maxPropImage = data.maxPropImage;
			if ( data.maxDocSize ) this._maxDocSize = data.maxDocSize;
			if ( data.tcUrl ) this._tcUrl = data.tcUrl;
			if ( data.setOTP ) this._setOTP = data.setOTP;
		}
		return r;
	}

	maxPagesPerDoc(): number {
		return this._maxPages!;
	}

	maxPropertyImages(): number {
		return this._maxPropImage!;
	}

	psTCUrl(): string {
		return this._tcUrl!;
	}

	maxDocSize(): number {
		return this._maxDocSize!;
	}

	setOTP(): boolean {
		return this._setOTP!;
	}

}

interface RestConfig {
	privateSellApi: () => IPSConfig;
	identityOTPApi: () => APIConfig;
}

const dev: RestConfig = {

	privateSellApi: () => new PSConfig( "https", "devgate.dubailand.gov.ae", "PrivateSale", undefined,
		1, 10, 2 * 1024, "https://mobile.dubailand.gov.ae/PrivateSaleApi/TermsandConditions/TermsAndConditions.pdf", true ),
	identityOTPApi: () => new BaseAPIConfig( "https", "devgate.dubailand.gov.ae", "Identity.OTP.API" ),
};

const qa: RestConfig = {
	privateSellApi: () => new PSConfig( "https", "stgapi.dubailand.gov.ae", "PrivateSaleAPI", undefined,
		1, 10, 2 * 1024, "https://mobile.dubailand.gov.ae/PrivateSaleApi/TermsandConditions/TermsAndConditions.pdf", false ),
	identityOTPApi: () => new BaseAPIConfig( "https", "stgapi.dubailand.gov.ae:8888", "OTP.Identity" ),
};

const prod: RestConfig = {
	privateSellApi: () => new PSConfig( "https", "mobile.dubailand.gov.ae", "PrivateSaleApi", undefined,
		1, 10, 2 * 1024, "https://mobile.dubailand.gov.ae/PrivateSaleApi/TermsandConditions/TermsAndConditions.pdf", false ),
	identityOTPApi: () => new BaseAPIConfig( "https", "mobile.dubailand.gov.ae", "Identity.OTP.API" ),
};

const configs: ConfigMap<RestConfig> = {
	dev: dev,
	qa: qa,
	production: prod,
};

const cfg = buildConfig<RestConfig, ConfigEnvironment>( "dev", configs );
export default cfg;
